import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetOperatorsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Operators/GetOperators`,
	params: {}
});

export const CreateOperatorRequest = (operator) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Operators/CreateOperator`,
	data: operator
});

export const DeleteOperatorRequest = (operator) => AxiosRequest({
	method: 'DELETE',
	url: `${config.API_URL}Operators/DeleteOperator`,
	data: operator
});

export const GetOperatorRequest = (operatorId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Operators/GetOperator`,
	params: { operatorId }
});

export const UpdateImageRequest = (operator) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Operators/UpdateImage`,
	data: operator
});

export const DeleteProjectRequest = (projectId) => AxiosRequest({
	method: 'DELETE',
	url: `${config.API_URL}Operators/DeleteProject`,
	params: { projectId }
});

export const CreateProjectRequest = (project) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Operators/CreateProject`,
	data: project
});

export const UpdateOperatorRequest = (operator) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Operators/UpdateOperator`,
	data: operator
});
